import './Loading.css'

function Loading() {
  return (
    <div className="loader"></div>
  )
}

export default Loading;